import gql from 'graphql-tag';

// A disbursement is a payout of money we were holding, so it is made of
// `payments` — the only table that records whether we were holding it. It used
// to read `invoice_payments` and `deposits`, which say how the guest paid, not
// who has the money.
const GET_LIST_DISBURSEMENTS = gql`
{
    disbursment_no
    bank_account_no
    bank_name
    received_amount
    charges
    platform_charges
    currency
    created_at
    e_disbursement_status {
      comment
      id
    }
    id
    image_url
    payable_amount
    remark
    status
    tenant_id
    updated_at
    tenant {
      name
    }
    payments {
      id
      payment_no
      amount
      received_currency
      status
      payment_type
      gateway_fee
      platform_fee
      gateway_order_id
      gateway_transaction_id
      booking_id
      created_at
      e_payment_status {
        comment
        id
      }
      e_payment_types {
        comment
        id
      }
    }
}
`;

export { GET_LIST_DISBURSEMENTS }
